/**
 * Flying club model. This class stores additional information about a business that is also a flying club (e.g.,
 * number of members, aircraft, etc.).
 */
export class FlyingClub {
  /**
   * Number of club members
   */
  clubMembers: number;

  /**
   * Number of club aircraft
   */
  clubAircraft: number;

  /**
   * Parses flying club
   * @param data {any} Flying club data as returned by API
   * @return {FlyingClub} Parsed flying club
   */
  static parse(data: any): FlyingClub {
    return {
      clubMembers: data.clubMembers,
      clubAircraft: data.clubAircraft
    };
  }
}
